// extracted by mini-css-extract-plugin
export default {"table":"table__90c6760f","empty":"empty__90c6760f"};